window.addEventListener(`DOMContentLoaded`, () => {
  const gotoBroker = document.querySelector('.js-link-broker')
  const openModalBtn = document.querySelector('.js-bpif-buy-online')
  const currFund = openModalBtn.getAttribute('data-fund')
  document.querySelectorAll('.js-broker-link').forEach(item => {
    let dataHref = item.getAttribute('data-href')
    let qrCode = item.getAttribute('data-img')
    let yaFooString = 'ym(10543570, \'reachGoal\', \'broker_out\', { current_fund: \''+currFund+'\', broker: \''+ qrCode +'\' } ); return true;'
    item.setAttribute('onclick', yaFooString)

    item.addEventListener('click', function() {

      document.querySelectorAll('.js-broker-link').forEach(i => {
        i.classList.remove('focus')
      })
      document.querySelectorAll('.js-qr-code-container img').forEach(el => {
        el.classList.add('hidden')
      })

      item.classList.add('focus')
      document.querySelector('.js-qr-code-container img.'+qrCode).classList.remove('hidden')
      gotoBroker.classList.remove('disabled')
      gotoBroker.setAttribute('onclick', yaFooString)
      gotoBroker.href = decodeURIComponent(dataHref)

      if (window.innerWidth < 1024) {
        window.open(decodeURIComponent(dataHref), '_blank')
      }
    })
  })
})
